import React, { useContext } from 'react';
import { AppContext, initialState } from '../../context/AppContext/context';

const initialLoadingModalState = initialState.loadingModal;

function useLoadingModal() {
  const { dispatch } = useContext(AppContext);

  const updateLoadingModal = React.useCallback(
    (payload: typeof initialLoadingModalState) => {
      dispatch({
        type: 'SET_LOADING_MODAL',
        payload,
      });
    },
    [dispatch],
  );

  const openLoadingModal = React.useCallback(
    (payload: Pick<typeof initialLoadingModalState, 'header' | 'message'>) => {
      dispatch({
        type: 'SET_LOADING_MODAL',
        payload: {
          ...initialLoadingModalState,
          ...payload,
          status: 'loading',
        },
      });
    },
    [dispatch],
  );

  const closeLoadingModal = React.useCallback(() => {
    const payload = initialState.loadingModal;

    dispatch({
      type: 'SET_LOADING_MODAL',
      payload,
    });
  }, [dispatch]);

  return {
    openLoadingModal,
    updateLoadingModal,
    closeLoadingModal,
  };
}

export default useLoadingModal;
